"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toElasticQuery = void 0;
var elastic_query_1 = require("./elastic-query");
Object.defineProperty(exports, "toElasticQuery", { enumerable: true, get: function () { return elastic_query_1.toElasticQuery; } });
//# sourceMappingURL=index.js.map